<template>
  <div class="bige">
    <section id="firstSection">
      <div class="parallax col1 notie" data-parallax="2">
        <div
          class="icon idtroc-tshirt"
          style="top:75vh; font-size:150px; width:100px;"
        ></div>
      </div>
      <div class="parallax col2 notie" data-parallax="1">
        <div class="icon idtroc-toy" style="top:70vh; font-size:250px;"></div>
      </div>
      <div class="parallax col5 notie" data-parallax="1.5">
        <div
          class="icon idtroc-book"
          style="top:55vh; font-size:200px; z-index:66;"
        ></div>
      </div>
      <div class="parallax col4 notie" data-parallax="2.5">
        <div
          class="icon idtroc-giving"
          style="top:85vh; font-size:150px; z-index:66;"
        ></div>
      </div>
      <div class="parallax col2 notie" data-parallax="2.5">
        <div
          class="icon idtroc-smart_hand_2"
          style="top:105vh; font-size:120px; z-index:66;"
        ></div>
      </div>
      <div class="parallax col3 notie" data-parallax="2">
        <div class="icon idtroc-shop" style="top:155vh; font-size:120px;"></div>
      </div>
      <div class="parallax col5 notie" data-parallax="1">
        <div
          class="icon idtroc-great"
          style="top:145vh; font-size:220px;"
        ></div>
      </div>
      <!-- -->
      <div
        class="head"
        v-touch:swipe="swipeHandler"
        v-touch:moving="movingHandler"
        v-touch:moved="movedHandler"
        v-touch:start="startHandler"
        v-touch:end="endHandler"
      >
        <div class="slider">
          <div class="bigeSlider" id="bigeSlider">
            <div
              class="prevNextButton prev notie"
              v-on:click="slidePrev"
              v-bind:class="{ disabled: isFirst }"
              v-if="notie"
            ></div>
            <div
              class="prevNextButton next notie"
              v-on:click="slideNext"
              v-bind:class="{ disabled: isLast }"
              v-if="notie"
            ></div>
            <div class="wrapper" id="headerWrapper">
              <div class="item169" v-on:click="setCurrent(0)">
                <video
                  v-on:mouseover="displayVideoControls"
                  v-on:mouseleave="hideVideoControls"
                  poster="@/assets/videos/idtroc-video-poster.gif"
                >
                  <source
                    src="@/assets/videos/why_idtroc.mp4"
                    type="video/mp4"
                  />
                  <track label="French" kind="captions" srclang="fr" src="" default>
                </video>
              </div>

              <div
                class="item169 notie"
                v-on:click="setCurrent(1)"
                v-if="notie"
              >
                <figure>
                  <img
                    src="@/assets/images/SVG/app_how_its_run.svg"
                    alt="trouvez un idtroc proche de vous"
                  />
                </figure>
                <h3>L’application IDTROC, comment ça marche ?</h3>
                <p>
                  Réservée aux membres des programmes fidélité OKÄIDI - OBAÏBI,
                  OXYBUL et ÏDKIDS, j’adhère en ligne ou en magasin pour
                  participer !
                </p>
              </div>
              <div
                class="item169 notie"
                v-on:click="setCurrent(2)"
                v-if="notie"
              >
                <figure>
                  <img
                    src="@/assets/images/SVG/trouver_un_idtroc.svg"
                    alt="trouvez un idtroc proche de vous"
                  />
                </figure>
                <h3>Choisissez un IDTROC à proximité!</h3>
                <p>
                  Grâce à l’application, je me géolocalise pour choisir mon
                  magasin participant à proximité.
                </p>
              </div>
              <div
                class="item169 notie"
                v-on:click="setCurrent(3)"
                v-if="notie"
              >
                <figure>
                  <img
                    src="@/assets/images/SVG/ajoutez_vos_articles_idtroc.svg"
                    alt="ajoutez vos articles vetements jeux et jouets"
                  />
                </figure>
                <h3>Enregistrez et étiquetez vos articles à la maison !</h3>
                <p>
                  Nouveau ! J’imprime mes étiquettes de chez moi. Je n’ai pas
                  d’imprimante ?
                  <br />Mon magasin le fait pour moi !
                </p>
              </div>
              <div
                class="item169 notie"
                v-on:click="setCurrent(4)"
                v-if="notie"
              >
                <figure>
                  <img
                    src="@/assets/images/SVG/deposez_et_vendeez_en_magasin.svg"
                    alt="déposez en magasin et mettez en vente"
                  />
                </figure>
                <h3>Déposez vos articles en magasin aux dates indiquées !</h3>
                <p>
                  Après contrôle qualité du magasin, je mets en rayon mes
                  articles validés dans l’espace dédié.
                </p>
              </div>
              <div
                class="item169 notie"
                v-on:click="setCurrent(5)"
                v-if="notie"
              >
                <figure>
                  <img
                    src="@/assets/images/SVG/obtenez_votre_carte_cadeau_idtroc.svg"
                    alt="obtenez des cartes cadeaux IDKIDS et ou Jacadi"
                  />
                </figure>
                <h3>Vos articles vendus se transforment en carte cadeau !</h3>
                <p>
                  Je peux suivre mes ventes sur l’application. Le montant final
                  de mes ventes est crédité via l’application sans frais ni
                  commission sur ma carte cadeau !
                </p>
              </div>
              <div
                class="item169 notie"
                v-on:click="setCurrent(6)"
                v-if="notie"
              >
                <figure>
                  <img
                    src="@/assets/images/SVG/donnez_vos_invendus.svg"
                    alt="Suivez vos ventes et donnez ou récupéreez vos invendus"
                  />
                </figure>
                <h3>Après la vente, donnez ou retirez vos invendus !</h3>
                <p>
                  Je souhaite donner mes invendus ? Inutile de me déplacer,
                  après la date limite, ils seront automatiquement donnés à
                  l’organisme/association parrainée par le magasin !
                </p>
              </div>
            </div>
          </div>
        </div>
        <ul class="dotNav notie">
          <li
            v-for="(item, index) in items"
            :class="{ active: current === index }"
            v-on:click="setCurrent(index)"
          ></li>
        </ul>
      </div>
      <h1>
        Pour vendre vos articles en magasin OKAÏDI-OBAÏBI, OXYBUL, ÏDKIDS et CATIMINI,
        <br />
        <b>téléchargez l’application !</b>
      </h1>
      <div class="cols">
        <div class="centered osReverse" v-bind:class="{ reverse: isAndroid }">
          <a
            v-bind:href="global.apple_link"
            v-bind:title="global.download_apple"
            target="_blank"
            rel="noopener"
          >
            <img
              class="download_button"
              src="@/assets/images/SVG/ios_download.svg"
              height="48"
              alt="telechargez idtroc sur ios"
            />
          </a>
          <a
            v-bind:href="global.google_link"
            v-bind:title="global.download_google"
            target="_blank"
            rel="noopener"
          >
            <img
              class="download_button"
              src="@/assets/images/SVG/google_play_FR.svg"
              height="48"
              alt="telechargez idtroc ur google play android"
            />
          </a>
        </div>
      </div>
      <h2 class="cont centered" v-html="message"></h2>
      <div class="cols cont">
        <div class="col">
          <div class="icon icon64 idtroc-blob_idtroc">
            <div class="ligature path1"></div>
            <div class="ligature path2"></div>
            <div class="ligature path3"></div>
          </div>
          <h3>Faites un geste responsable</h3>
          <p>
            Faites le tri dans vos armoires, transmettez, recyclez et
            engagez-vous pour une consommation plus responsable !
          </p>
        </div>
        <div class="col">
          <div class="icon icon64 idtroc-product_add"></div>
          <h3>Gérez vos articles</h3>
          <p>
            Grâce à l’application, trouvez les ventes IDTROC proches de chez
            vous, ajoutez vos articles et récupérez vos étiquettes !
          </p>
        </div>
        <div class="col">
          <div class="icon icon64 idtroc-shop_search"></div>
          <h3>Vendez facilement</h3>
          <p>
            Déposez tous vos articles en une seule fois dans le magasin de votre
            choix. Profitez de la communauté de nos clients pour vendre vos
            articles plus facilement !
          </p>
        </div>
        <div class="col" v-if="showAll">
          <div class="icon icon64 idtroc-quality"></div>
          <h3>En toute confiance</h3>
          <p>
            Le magasin valide la qualité de vos articles, gère la relation avec
            les clients et vous garantit le paiement de votre carte cadeau !
          </p>
        </div>
        <div class="col" v-if="showAll">
          <div class="icon icon64 idtroc-giftcard"></div>
          <h3>Obtenez des cartes cadeaux</h3>
          <p>
            Récupérez 100% du montant de vos ventes en carte cadeau sans frais
            ni commission, la vente est entièrement prise en charge par votre
            magasin !
          </p>
        </div>
        <div class="col" v-if="showAll">
          <div class="icon icon64 idtroc-give"></div>
          <h3>Une démarche solidaire</h3>
          <p>
            Après la vente, vous pouvez choisir de récupérer ou de donner vos
            invendus à l’association ou organisation parrainée par le magasin !
          </p>
        </div>
      </div>
      <div class="centered">
        <a v-on:click="showMore" id="showMore" class="hyperlink">{{
          loadmore
        }}</a>
      </div>
    </section>

    <section>
      <!-- -->
      <br />
      <div class="icon icon64 idtroc-share2"></div>
      <h1>Ils parlent de l’IDTROC !</h1>
      <!---->
      <div class="cols cont">
        <div class="col">
          <div class="video">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/MEQ60VlHxPc"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style="position:absolute; border: 0"
              title="on parle d'IDTROC dans le journal tv france2"
            ></iframe>
          </div>
          <h4>Journal TV France 2</h4>
          <p class="left">
            « Forcement on se rappelle quand on leur a mis, mais je me dis que
            cela va faire très plaisir à quelqu’un »
            <br />en magasin Okaïdi - Obaïbi
          </p>
        </div>
        <div class="col">
          <div class="video">
            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/_XrXGnwK5Zw"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style="position:absolute; border: 0"
              title="France 3 prend la parole pour IDTROC !"
            ></iframe>
          </div>
          <h4>Journal France 3</h4>
          <p class="left">
            "C'est le mode de consommation tendance, le recyclable !"
            <br />Vente de livres chez Oxybul
          </p>
        </div>
        <div class="col">
          <div class="video">
            <iframe
              title="les clients parlent d'idtroc sur youtube by google"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/vLU7y0w02qE"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style="position:absolute;"
            ></iframe>
          </div>
          <h4>Les clients en parlent</h4>
          <p class="left">interview de clients et utilisateurs IDTROC</p>
        </div>
      </div>
    </section>
    <section>
      <br />
      <div class="icon icon64 idtroc-marker"></div>
      <h2>
        <br />Retrouvez-nous dans votre magasin Okaïdi, Obaïbi, Oxybul
        et ÏDKIDS pour participer aux ventes !
      </h2>
      <div class="cols cont">
        <div class="col forthy centered">
          <figure class="centered">
            <a
              href="https://www.okaidi.fr/idtroc-4"
              title="vente de vêtement d'occasion obaïbi acceder au site"
              target="_blank"
              rel="noopener"
            >
              <img
                src="@/assets/images/SVG/okaidi_logo.svg"
                width="120"
                height="48"
                alt="logo okaidi sur idtroc"
              />
            </a>
          </figure>
          <h4>Okaïdi</h4>
          <p class>Vêtements enfant 4-14 ans</p>
          <a
            class="hyperlink"
            href="https://www.okaidi.fr/idtroc-4"
            title="vente de vêtement d'occasion okaïdi acceder au site"
            target="_blank"
            rel="noopener"
            >idtroc sur Okaïdi</a
          >
        </div>
        <div class="col forthy centered">
          <figure class="centered">
            <a
              href="https://www.okaidi.fr/idtroc-4"
              title="vente de vêtement d'occasion obaïbi acceder au site"
              target="_blank"
              rel="noopener"
            >
              <img
                src="@/assets/images/SVG/obaibi_logo.svg"
                width="120"
                height="48"
                alt="logo obaibi sur idtrocf"
              />
            </a>
          </figure>
          <h4>Obaïbi</h4>
          <p class>Vêtements bébé 0-4 ans</p>
          <a
            class="hyperlink"
            href="https://www.okaidi.fr/idtroc-4"
            title="vente de vêtement d'occasion obaïbi acceder au site"
            target="_blank"
            rel="noopener"
            >idtroc sur Obaïbi</a
          >
        </div>
        <div class="col forthy centered">
          <figure class="centered">
            <a
              href="https://www.oxybul.com/id-troc"
              title="vente de livres jeux et jouets d'occasion Oxybul acceder au site"
              target="_blank"
              rel="noopener"
            >
              <img
                src="@/assets/images/SVG/oxybul_logo.svg"
                width="120"
                height="48"
                alt="logo oxybul sur idtroc"
              />
            </a>
          </figure>
          <h4>Oxybul</h4>
          <p>Livres jeux et jouets 0-12 ans</p>
          <a
            class="hyperlink"
            href="https://www.oxybul.com/id-troc"
            title="vente de livres jeux et jouets d'occasion Oxybul acceder au site"
            target="_blank"
            rel="noopener"
            >idtroc sur Oxybul</a
          >
        </div>
        <div class="col forthy centered">
          <figure class="centered">
            <a
              href="https://www.catimini.com/fr-fr/website/465-idtroc"
              title="vente de livres jeux et jouets d'occasion Oxybul acceder au site"
              target="_blank"
              rel="noopener"
            >
              <img
                src="@/assets/images/SVG/catimini_logo.svg"
                width="120"
                height="48"
                alt="logo catimini sur idtroc"
              />
            </a>
          </figure>
          <h4>Catimini</h4>
          <p>Vêtements bébé et enfant 0-14 ans</p>
          <a
            class="hyperlink"
            href="https://www.catimini.com/fr-fr/website/465-idtroc"
            title="vente de vêtement enfant d'occasion Catimini acceder au site"
            target="_blank"
            rel="noopener"
            >idtroc sur Catimini</a
          >
        </div>
      </div>
    </section>
    <section>
      <br />
      <div class="centered">
        <div class="icon icon64 idtroc-give centered inline"></div>
      </div>
      <br />
      <h2>
        Que deviennent vos invendus non retirés ?
        <br />
        <b
          >Nous nous engageons à faire don de vos invendus aux associations et
          organismes partenaires.</b
        >
      </h2>
      <br />
      <div class="cols cont">
        <div class="col centered">
          <img
            src="@/assets/images/lovebag.png"
            alt="le love bag avec idtroc seconde vie"
            height="120"
          />
          <h4>OKAÏDI et LE LOVEBAG</h4>
          <p class="cont justified">
            Vos dons, sont triés, redistribués ou recyclés avec le LOVE BAG dans
            une démarche éco-responsable.
          </p>
        </div>
        <div class="col centered">
          <img
            src="@/assets/images/oxybul_dons.svg"
            alt="logo le relais avec jacadi paris"
            height="120"
          />
          <h4>Oxybul et les accosiations locales</h4>
          <p class="col justified">
            Chaque magasin parraine une association locale qui agit en faveur
            des enfants et des familles et lui redistribue vos dons.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Parallax from "@/assets/js/parallax";

export default {
  name: "Landing",
  props: {
    date: {
      type: String,
      required: false,
      default: "today"
    }
  },
  data() {
    return {
      notie: true,
      isFirst: true,
      isLast: false,
      slider: null,
      items: null,
      current: 0,
      isDrag: false,
      startX: null,
      currentX: null,
      loadmore: "+ afficher plus d'avantages",
      showAll: false,
      message: `<b>Ensemble, donnons une seconde vie aux vêtements, livres, jeux et jouets de vos enfants !</b>
        <br />Participer à IDTROC, c'est faire le tri dans vos armoires, transmettre, recycler
        <br />et s'engager ensemble pour une consommation plus responsable.`,
      nextEvents: [
        {
          brands: ["okaidi", "obaibi"],
          seasons: ["autumn", "winter"],
          startAt: "12 Juillet 2020",
          endAt: "20 Juillet 2020",
          startPremium: "11 juillet 2020",
          startDepositor: "7 Juillet 2020"
        }
      ]
    };
  },
  mounted: function() {
    // window.addEventListener("mouseup", this.stopDrag);
    this.slider = document.getElementById("headerWrapper");
    this.items = this.slider.getElementsByClassName("item169");
    this.$nextTick(function() {
      this.pageInit();
    });
  },
  methods: {
    showMore: function() {
      if (this.showAll) {
        this.loadmore = "- Afficher plus d'avantages";
        this.showAll = false;
        window.scrollTo({
          top: document.getElementById("showMore").getBoundingClientRect().top,
          left: 0,
          behavior: "smooth"
        });
      } else {
        this.loadmore = "- Afficher moins";
        this.showAll = true;
      }
    },
    setCurrent: function(i) {
      if (i === this.current)
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      this.current = i;
      this.slideTo();
    },
    startHandler: function(e) {
      if (typeof e.targetTouches !== "undefined")
        this.currentX = e.targetTouches[0].pageX;
      else this.currentX = e.clientX;
      if (this.startX === null) {
        this.startX = this.currentX;
      }
      this.isDrag = true;
    },
    endHandler: function() {
      this.startX = null;
      this.isDrag = false;
    },
    movedHandler: function(e) {
      // this.isDrag = false;
    },
    movingHandler: function(e) {
      if (!this.isDrag) return false;
      if (typeof e.targetTouches !== "undefined") {
        // is touch screen setup start at targetTouches[0].pageX
        this.currentX = e.targetTouches[0].pageX;
      } else {
        this.currentX = e.clientX;
      }
      var dif = this.startX - this.currentX / 2;
      var style = window.getComputedStyle(this.slider);
      // var matrix = new WebKitCSSMatrix(style.webkitTransform);
      // console.log("matrix ", matrix);
      //var pos = -document.getElementById("bigeSlider").offsetWidth * this.current;
      // this.slider.style.transform = "translateX(" + (pos - dif) + "px)";
      // document.getElementById("bigeSlider").style.transform = "translateX(" + -dif + "px)";
    },
    swipeHandler: function(dir) {
      switch (dir) {
        case "left":
          this.slideNext();
          break;
        case "right":
          this.slidePrev();
          break;
      }
    },
    slideNext: function() {
      if (this.isLast) return false;
      this.current++;
      this.slideTo();
    },
    slidePrev: function() {
      if (this.isFirst) return false;
      this.current--;
      this.slideTo();
    },
    slideTo: function() {
      if (this.current === 0) this.isFirst = true;
      else this.isFirst = false;
      if (this.current === this.items.length - 1) this.isLast = true;
      else this.isLast = false;
      var pos =
        -document.getElementById("bigeSlider").offsetWidth * this.current;
      this.slider.style.transform = "translateX(" + pos + "px)";
    },
    isNotIe: function() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");
      // || !!navigator.userAgent.match(/Trident.*rv\:11\./)
      if (msie > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return false;
      } else {
        return true;
      }
    },
    pageInit: function() {
      // TODO WORK WITH PARALLAX
      this.notie = this.isNotIe();
      this.wrapper = document.getElementById("bigeSlider");
      this.header = document.getElementById("header");
      this.slideParagraphs = this.wrapper.getElementsByTagName("p");
      if (this.notie) {
        const { init } = new Parallax(
          "parallax",
          function(pos) {
            if (!this.notie) {
              this.header.classList.add("sticky");
              return false;
            }
            if (document.getElementById("objectiveBottomSecondary")) {
              if (
                pos >
                  this.slider.getBoundingClientRect().top +
                    this.slider.getBoundingClientRect().height +
                    window.innerHeight &&
                document
                  .getElementById("objectiveBottomSecondary")
                  .getBoundingClientRect().top +
                  document
                    .getElementById("objectiveBottomSecondary")
                    .getBoundingClientRect().height -
                  window.innerHeight >
                  0
              ) {
                document
                  .getElementById("objectiveBottom")
                  .classList.add("displayed");
              } else if (
                document
                  .getElementById("objectiveBottomSecondary")
                  .getBoundingClientRect().top +
                  document
                    .getElementById("objectiveBottomSecondary")
                    .getBoundingClientRect().height -
                  window.innerHeight <
                0
              ) {
                document
                  .getElementById("objectiveBottom")
                  .classList.remove("displayed");
              } else {
                document
                  .getElementById("objectiveBottom")
                  .classList.remove("displayed");
              }
            }
            if (pos < 0 && document.getElementById("logo")) {
              document.getElementById("logo").style.height =
                this.slider.getBoundingClientRect().top.toFixed(2) - 40 + "px";
              return false;
            }
            if (pos <= 100 && document.getElementById("firstSection")) {
              document.getElementById("firstSection").style.transform =
                "translate3D(0, " + (parseInt(pos) + 50) + "px, 0)";
            }
            if (1 - pos / 100 > 0) {
              for (let item of this.slideParagraphs) {
                item.style.opacity = 1 - pos / 100;
              }
            }
            let dif = (100 - pos / 4) / 100;
            if (dif > 0.6 && this.wrapper) {
              this.wrapper.style.transform = "scale(" + dif.toFixed(2) + ")";
            } else {
              this.wrapper.style.transform = "scale(0.6)";
            }
            if (this.slider.getBoundingClientRect().top.toFixed(2) - 40 > 48) {
              document.getElementById("logo").style.height =
                this.slider.getBoundingClientRect().top.toFixed(2) - 40 + "px";
              if (this.header.classList.contains("sticky"))
                this.header.classList.remove("sticky");
            } else {
              document.getElementById("logo").style.height = "48px";
              if (!this.header.classList.contains("sticky"))
                this.header.classList.add("sticky");
            }
          }.bind(this)
        );
        init();
      } else {
        this.header.classList.add("sticky");
      }
      return "something";
    },
    displayVideoControls: function(e) {
      e.target.setAttribute("controls", "controls");
    },
    hideVideoControls: function(e) {
      e.target.removeAttribute("controls");
    }
  },
  computed: {
    global() {
      return this.$store.getters.global;
    },
    isAndroid() {
      return this.$store.getters.isAndroid;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Idtroc.vue